import { useCookieValue as useCookieValueBase } from '@repo/hooks-use-cookie-value'

export const useCookieValue = useCookieValueBase
